const rdatez = require('./dist/js/react-datez.js')

module.exports = {
    ReactDatez: rdatez.ReactDatez,
    ReduxReactDatez: rdatez.ReduxReactDatez
}
